import {useRef} from 'react';
import styled, {css} from 'styled-components';

import {scToTwColour} from '../../theme';

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  children?: React.ReactNode;
};
export function SimpleTextField({
  children,
  required,
  ...props
}: Props): React.JSX.Element {
  const uuid = useRef(Math.round(Math.random() * 1000).toString());

  return (
    <>
      {children && (
        <Label
          className="small-upper"
          required={!!required}
          htmlFor={uuid.current}
        >
          {children}
        </Label>
      )}

      <Input {...props} type="text" id={uuid.current} />
    </>
  );
}

export const SimpleTextFieldStyle = css`
  border: solid 1px;
  border-radius: 5px;
  padding: 0 0.5em;
  line-height: 2em;
  height: 2em;
  position: relative;
  outline: 0;
  border-color: ${scToTwColour('theme.colours.slate7')};
  width: 100%;
  background-color: transparent;
  outline: 0;

  &:focus {
    border-color: ${scToTwColour('theme.colours.blue8')};
  }
`;
const Label = styled.label<{required: boolean}>`
  position: relative;
  width: 100%;
  font-size: 0.875rem;
  color: ${scToTwColour('theme.colours.slate11')};
`;
const Input = styled.input`
  ${SimpleTextFieldStyle}
`;
